import { useEffect, useState } from "react";
import { animated, useSpring } from "react-spring";
import { Video } from "../../shared/Video";
import { springConfigs } from "../../../constants/springConfigs";

const AssetContainer = ({ active, videoStyle, videoStartSecond }) => {
  const { liftAsset } = useSpring({
    from: { liftAsset: "0%" },
    to: { liftAsset: active ? "-10%" : "0%" },
    config: {
      tension: 180,
      friction: 120,
      mass: 10,
      precision: 0.00001,
    },
  });
  const [showAsset, showAssetSet] = useState(true);
  useEffect(() => {
    // reset showAsset when column is active again
    if (active && !showAsset) showAssetSet(true);
  }, [active, showAsset]);

  const getOpacity = () => {
    if (active) return 1;
    return 0;
  };

  const { opacity } = useSpring({
    from: { opacity: 0 },
    to: { opacity: getOpacity() },
    config: active ? springConfigs.assetAppears : springConfigs.columnInactive,
    onRest: ({ finished, value }) => {
      if (finished && value.opacity === 0) {
        showAssetSet(false);
      }
    },
  });

  // can render if not using active
  return (
    <animated.div
      {...{
        id: "AssetContainer",
        style: {
          opacity,
          position: "absolute",
          right: "-300px",
          top: liftAsset,
        },
      }}
    >
      {showAsset && (
        <Video
          {...{
            videoStartSecond,
            videoStyle,
            containerStyle: {},
          }}
        />
      )}
    </animated.div>
  );
};

export default AssetContainer;
